import createCache from "@emotion/cache";

/**
 * Single shared Emotion cache for the whole app.
 *
 * Why this exists
 * ---------------
 * MUI styles every component through Emotion. Without an explicit, app-level
 * cache, MUI lazily spins up its OWN default Emotion cache the first time any
 * styled component renders. That implicit, on-demand initialisation is what
 * created an init-time dependency edge from the MUI/Emotion runtime back into
 * the React core — so when Rollup pulled React/MUI/Emotion into separate
 * vendor chunks, the two chunks ended up importing each other and Rollup
 * emitted a runtime TDZ crash ("Cannot access X before initialization") that
 * blanked the app (see the historical note in vite.config.ts).
 *
 * Providing one shared cache at the app root via <CacheProvider> is the
 * canonical fix: Emotion's insertion path is now deterministic and owned by
 * the app, which lets the bundler split React / MUI+Emotion / leaf libs into
 * distinct cacheable chunks without re-introducing the cycle.
 *
 * It is created once at module scope (a stable singleton) so it is never
 * re-created across renders. `key: "mui"` matches MUI's own default cache key
 * so generated class names and <style> tags stay consistent.
 */
export const emotionCache = createCache({ key: "mui" });
